/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignaturePlace } from '../../models/signature-place';

export interface GetSignaturePlacesList$Params {
}

export function getSignaturePlacesList(http: HttpClient, rootUrl: string, params?: GetSignaturePlacesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SignaturePlace>>> {
  const rb = new RequestBuilder(rootUrl, getSignaturePlacesList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SignaturePlace>>;
    })
  );
}

getSignaturePlacesList.PATH = '/signature-places';
